<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :block-content="false"
      :view-content="false"
      :columns="columns"
      :type="type"
      :add-component-name="addComponentName"
      :add-type="addType"
      :edit-content="true"
      :delete-content="true"
      :edit-component="editComponent"
    >
      <template #cell(addresses)="data">
        <ul
          v-if="data.item.addresses && data.item.addresses.length"
          class="addresses-list mb-0 pl-0"
        >
          <li
            v-for="(address, index) in data.item.addresses"
            :key="index"
            class="d-flex align-items-start mb-1"
          >
            <feather-icon
              icon="MapPinIcon"
              size="16"
              class="text-dark mr-50 flex-shrink-0"
            />
            <span
              class="address-text-truncate"
              :title="formatAddress(address)"
            >
              {{ formatAddress(address) }}
            </span>
          </li>
        </ul>
        <span
          v-else
          class="text-muted"
        >—</span>
      </template>
      <template #cell(attachments)="data">
        <div class="d-flex flex-column">
          <div
            v-for="attachment in data.item.attachments"
            :key="attachment.id"
          >
            <a
              :href="attachment.url"
              target="_blank"
              class="text-dark cursor-pointer"
            >
              <feather-icon
                icon="FileIcon"
                size="18"
              />
              {{ attachment.name || attachment.file_name || `Attachment #${attachment.id}` }}
            </a>
          </div>
        </div>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      viewContent: true,
      addType: 'Add SFDA Lab',
      addComponentName: 'add-sfda-lab',
      type: 'page',
      filter: {},
      editComponent: 'edit-sfda-lab',
      columns: [
        { key: 'name', label: 'Name' },
        { key: 'valid_until', label: 'valid until' },
        { key: 'addresses', label: 'addresses' },
        { key: 'certificate_number', label: 'certificate number' },
        { key: 'attachments', label: 'attachments' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    apiUrl() {
      const base = 'sfda-labs?'
      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      const queryParams = Object.entries(this.filter)
        .filter(([key, value]) => key && value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')

      return `${base}${queryParams}`
    },
  },
  methods: {
    filterTypes(type) {
      this.types = this.status.filter(item => item.text !== type)
    },
    formatAddress(address) {
      if (address == null) return ''
      if (typeof address === 'string') return address
      if (typeof address === 'object') {
        return address.address || address.name || address.title
          || Object.values(address).filter(Boolean).join(', ')
      }
      return String(address)
    },
  },
}
</script>

<style scoped>
.addresses-list {
  list-style: none;
  min-width: 12rem;
}
.addresses-list li {
  font-size: 0.85rem;
  line-height: 1.3;
}

.address-text-truncate {
  display: inline-block;
  max-width: 18rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
